import { render } from "./FormOverview.vue?vue&type=template&id=036b883a"
import script from "./FormOverview.vue?vue&type=script&lang=js"
export * from "./FormOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__